'use client'

import { useEffect } from 'react'

import { useChangeBaseColor } from '@/hooks/useChangeBaseColor'

export function BaseColorSetter() {
  useChangeBaseColor('bg-theme-light')

  useEffect(() => {
    if (typeof performance !== 'undefined') {
      performance.mark('cities-rendered')
    }
  }, [])

  return null
}
